/**
 * Real geographic coordinates for the Odyssey Map (S05 Act III).
 * The lat/lng ticker interpolates between these three points as the user scrolls.
 */

export type MapWaypoint = {
  id: "queens" | "alba" | "huila";
  name: string;
  sub: string;
  lat: number;
  lng: number;
  /** Human-readable DMS string for the ticker */
  label: string;
  /** Act context */
  context: string;
};

export const odysseyRoute: MapWaypoint[] = [
  {
    id: "queens",
    name: "QUEENS",
    sub: "NEW YORK",
    lat: 40.7306,
    lng: -73.9352,
    label: "40°43'50\"N · 73°56'06\"W",
    context: "the back room",
  },
  {
    id: "alba",
    name: "ALBA",
    sub: "PIEMONTE",
    lat: 44.7002,
    lng: 8.0356,
    label: "44°42'00\"N · 08°02'08\"E",
    context: "the white truffle war",
  },
  {
    id: "huila",
    name: "HUILA",
    sub: "COLOMBIA",
    lat: 2.5359,
    lng: -75.5277,
    label: "02°32'09\"N · 75°31'39\"W",
    context: "the coffee cartel",
  },
];

/**
 * Linear interpolation between waypoints given a scroll progress 0..1.
 * 0 = Queens, 0.5 = Alba, 1 = Huila.
 */
export function interpolateRoute(progress: number): {
  lat: number;
  lng: number;
} {
  const p = Math.max(0, Math.min(1, progress));
  const segment = p * (odysseyRoute.length - 1);
  const idx = Math.floor(segment);
  const frac = segment - idx;
  const a = odysseyRoute[idx];
  const b = odysseyRoute[Math.min(idx + 1, odysseyRoute.length - 1)];
  return {
    lat: a.lat + (b.lat - a.lat) * frac,
    lng: a.lng + (b.lng - a.lng) * frac,
  };
}

/**
 * Format a lat/lng pair as a DMS ticker string.
 * Example: 40.7306, -73.9352 -> "40°43'50\"N · 73°56'06\"W"
 */
export function formatCoord(lat: number, lng: number): string {
  const latDMS = toDMS(Math.abs(lat));
  const lngDMS = toDMS(Math.abs(lng));
  const latDir = lat >= 0 ? "N" : "S";
  const lngDir = lng >= 0 ? "E" : "W";
  return `${latDMS}${latDir} · ${lngDMS}${lngDir}`;
}

function toDMS(decimal: number): string {
  const deg = Math.floor(decimal);
  const minFloat = (decimal - deg) * 60;
  const min = Math.floor(minFloat);
  const sec = Math.round((minFloat - min) * 60);
  return `${String(deg).padStart(2, "0")}°${String(min).padStart(2, "0")}'${String(sec).padStart(2, "0")}"`;
}
